import {
    GET_REFERRAL_COMMENTS,
    GET_REFERRAL_COMMENTS_SUCCESS,
    GET_REFERRAL_COMMENTS_FAILED,

    SUBMIT_REFERRAL_COMMENT_FORM,
    SUBMIT_REFERRAL_COMMENT_FORM_SUCCESS,
    SUBMIT_REFERRAL_COMMENT_FORM_FAILED,

    DELETE_REFERRAL_COMMENT,
    DELETE_REFERRAL_COMMENT_SUCCESS,
    DELETE_REFERRAL_COMMENT_FAILED,
} from '../../constants/actionTypes';

const INIT_STATE = {
    loading: false,
    referralComments: [],
    submittingForm: false,
    error: null,
    deleting: false,
};

const CountryReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_REFERRAL_COMMENTS:
            return { ...state, loading: true };
        case GET_REFERRAL_COMMENTS_SUCCESS: 
            return { ...state, referralComments: action.payload.data, total: action.payload.total,  loading: false, error: null };
        case GET_REFERRAL_COMMENTS_FAILED:
            return { ...state, error: action.payload, loading: false };

        case SUBMIT_REFERRAL_COMMENT_FORM:
            return { ...state, error: null, submittingForm: true };
        case SUBMIT_REFERRAL_COMMENT_FORM_SUCCESS:
            const alreadyExists = state.referralComments.find((item) => item.id === action.payload.id);
            let referralComments;
            let total = state.total;
            if (!alreadyExists) {
                referralComments = [...state.referralComments, action.payload];
                total += 1;
            } else {
                referralComments = state.referralComments.map((item) => {
                if (item.id === action.payload.id) {
                  return action.payload;
                }
                return item;
              });
            }
            return { ...state, total,  referralComments, submittingForm: false };
        case SUBMIT_REFERRAL_COMMENT_FORM_FAILED:
            return { ...state, error: action.payload, submittingForm: false };

        case DELETE_REFERRAL_COMMENT:
            return { ...state, error: null, deleting: true };
        case DELETE_REFERRAL_COMMENT_SUCCESS:
            return { ...state, total: state.total - 1, referralComments: state.referralComments.filter(item => item.id !== action.payload) , deleting: false };
        case DELETE_REFERRAL_COMMENT_FAILED:
            return { ...state, error: action.payload, deleting: false };
        default: return { ...state };
    }
}

export default CountryReducer;